import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export default function FAQAccordion({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="space-y-2">
      {items.map((item, idx) => (
        <div key={idx} className="border border-border rounded-lg overflow-hidden">
          <button
            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            className="w-full flex items-center justify-between p-4 hover:bg-muted/50 transition-colors text-left"
          >
            <h3 className="font-semibold text-sm">{item.question}</h3>
            <ChevronDown
              className={cn(
                "w-5 h-5 text-muted-foreground transition-transform flex-shrink-0",
                openIndex === idx && "rotate-180"
              )}
            />
          </button>
          
          {openIndex === idx && (
            <div className="bg-muted/30 border-t border-border p-4">
              <p className="text-sm text-muted-foreground leading-relaxed">{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}